import 'es6-promise';
import loadReact from '@sfly/uig-cdn-libraries/react_16_8';

async function main() {
    await loadReact();

    require('../smsTemplate');
}

main().catch(window.console.error);
